import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const SIGNUP_URL = generateUrl()

const signupServiceApiInstance = axios.create({
    baseURL: `${SIGNUP_URL}/signup`
})

signupServiceApiInstance.interceptors.request.use(onRequestSuccess, undefined)
signupServiceApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default signupServiceApiInstance
